export const isViewOwnProfile = () => {
    const userDetail = JSON.parse(localStorage.getItem('user') || "{}");
    if (!userDetail?.user?.permissions?.people && !userDetail?.user?.permissions?.positionsTargets && !userDetail?.user?.permissions?.folders && !userDetail?.user?.permissions?.users && userDetail?.user?.permissions?.viewOwnProfileOnly && userDetail?.user?.role !== "Super Admin") {
        return true;
    }
    return false;
}